import { render, staticRenderFns } from "./MainVideo.vue?vue&type=template&id=04a81386&"
import script from "./MainVideo.vue?vue&type=script&lang=js&"
export * from "./MainVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports